import api from './api';
import { MEMBER_URLS } from '../components/config/apiConfig';

const memberService = {
  // Dashboard
  getDashboard: async () => {
    const response = await api.get(MEMBER_URLS.DASHBOARD);
    return response.data;
  },
  
  // Profile
  getProfile: async () => {
    const response = await api.get(MEMBER_URLS.PROFILE);
    return response.data;
  },
  
  updateProfile: async (profileData) => {
    const response = await api.put(MEMBER_URLS.PROFILE, profileData);
    return response.data;
  },
  
  // Resources
  getMemberResources: async (params) => {
    const response = await api.get(MEMBER_URLS.RESOURCES, { params });
    return response.data;
  },
  
  // Payments
  getMemberPayments: async () => {
    const response = await api.get(MEMBER_URLS.PAYMENTS);
    return response.data;
  },
  
  // Professional Listing
  createProfessionalListing: async (listingData) => {
    try {
      const response = await api.post(MEMBER_URLS.PROFESSIONAL_LISTING, listingData);
      return response.data;
    } catch (error) {
      console.error('Error creating professional listing:', error);
      // Enhance error handling by adding more context to the error
      if (error.response && error.response.data) {
        error.additionalInfo = error.response.data;
      }
      throw error;
    }
  },
  
  verifyProfessionalListingPayment: async (paymentData) => {
    try {
      const response = await api.post(MEMBER_URLS.VERIFY_PROFESSIONAL_LISTING_PAYMENT, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error verifying professional listing payment:', error);
      // Add more context to the error
      if (error.response && error.response.data) {
        error.additionalInfo = error.response.data;
      }
      throw error;
    }
  },
  
  getProfessionalListingStatus: async () => {
    try {
      const response = await api.get(MEMBER_URLS.PROFESSIONAL_LISTING_STATUS);
      return response.data;
    } catch (error) {
      console.error('Error getting professional listing status:', error);
      if (error.response && error.response.data) {
        error.additionalInfo = error.response.data;
      }
      throw error;
    }
  },
  
  // New methods for professional listing
  createNonMemberProfessionalListing: async (listingData) => {
    const response = await api.post(MEMBER_URLS.NON_MEMBER_PROFESSIONAL_LISTING, listingData);
    return response.data;
  },
  
  checkProfessionalListingPaymentStatus: async (referenceId) => {
    const response = await api.get(`${MEMBER_URLS.PROFESSIONAL_LISTING_PAYMENT_STATUS}/${referenceId}`);
    return response.data;
  },
  
  // Programs
  getMemberPrograms: async () => {
    const response = await api.get(MEMBER_URLS.PROGRAMS);
    return response.data;
  },
  
  registerForProgram: async (programId, registrationData) => {
    const response = await api.post(MEMBER_URLS.PROGRAM_REGISTRATION(programId), registrationData);
    return response.data;
  }
};

export default memberService;
